import { render, staticRenderFns } from "./DropdownValueDeleteDialog.vue?vue&type=template&id=081a7fa5"
import script from "./DropdownValueDeleteDialog.vue?vue&type=script&lang=js"
export * from "./DropdownValueDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports